import { AnimatePresence } from 'framer-motion';
import React, { useEffect } from "react";
import { Route, Routes, useLocation } from 'react-router-dom';

// Layout
import Layout from './components/layout/Layout';

// Pages - Import these when created
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import ApplicationsList from './pages/applications/ApplicationsList';
import Calendar from './pages/calendar/Calendar';
import CandidateDetail from './pages/candidates/CandidateDetail';
import CandidatesList from './pages/candidates/CandidatesList';
import Chat from './pages/Chat';
import Dashboard from './pages/Dashboard';
import EmployeeForm from './pages/employees/EmployeeForm';
import EmployeesList from './pages/employees/EmployeesList';
import EmployeeTimesheets from './pages/employees/EmployeeTimesheets';
import FormBuilder from './pages/FormBuilder';
import FormEdit from './pages/FormEdit';
import FormsList from './pages/FormsList';
import FormSubmissions from './pages/FormSubmissions';
import FormView from './pages/FormView';
import InvoiceDetail from './pages/invoices/InvoiceDetail';
import InvoicesList from './pages/invoices/InvoicesList';
import JobForm from './pages/jobs/JobForm';
import JobsList from './pages/jobs/JobsList';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import Register from './pages/Register';
import Settings from './pages/Settings';

function App() {
  const location = useLocation();
  
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <AuthProvider>
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          {/* Public auth routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected area */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes location={location} key={location.pathname}>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/jobs" element={<JobsList />} />
                    <Route path="/jobs/new" element={<JobForm />} />
                    <Route path="/jobs/:id/edit" element={<JobForm />} />
                    <Route path="/candidates" element={<CandidatesList />} />
                    <Route path="/candidates/:id" element={<CandidateDetail />} />
                    <Route path="/applications" element={<ApplicationsList />} />
                    <Route path="/forms" element={<FormsList />} />
                    <Route path="/forms/create" element={<FormBuilder />} />
                    <Route path="/forms/:id" element={<FormView />} />
                    <Route path="/forms/edit/:id" element={<FormEdit />} />
                    <Route path="/forms/:id/submissions" element={<FormSubmissions />} />
                    <Route path="/chat" element={<Chat />} />
                    <Route path="/invoices" element={<InvoicesList />} />
                    <Route path="/invoices/:id" element={<InvoiceDetail />} />
                    <Route path="/employees" element={<EmployeesList />} />
                    <Route path="/employees/new" element={<EmployeeForm />} />
                    <Route path="/employees/:id/edit" element={<EmployeeForm />} />
                    <Route path="/employees/:id/timesheets" element={<EmployeeTimesheets />} />
                    <Route path="/calendar" element={<Calendar />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* 404 route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AnimatePresence>
    </AuthProvider>
  );
}

export default App;
